//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[[0,"Type",1,0]],[],[]];
SPLM.AME.CreateReportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.CreateReportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.CreateReportBuilder.Types = Object.freeze({
    "AspectListFunction" : "AspectListFunction", "AspectListLocation" : "AspectListLocation", "BillOfMaterial" : "BillOfMaterial", "BillOfMaterialCrossref" : "BillOfMaterialCrossref", "CableDiagram" : "CableDiagram", "CableList" : "CableList", "ConnectionListBomElectrical" : "ConnectionListBomElectrical", "ConnectionListElectrical" : "ConnectionListElectrical", "ConnectionListHose" : "ConnectionListHose", "ConnectionListTube" : "ConnectionListTube", "TableOfContents" : "TableOfContents", "ProjectTitlePage" : "ProjectTitlePage", "TerminalDiagram" : "TerminalDiagram", "TerminalDiagramCrossref" : "TerminalDiagramCrossref", "TerminalMatrixDiagram" : "TerminalMatrixDiagram", "TerminalMatrixDiagramCrossref" : "TerminalMatrixDiagramCrossref", "ConnectionBomHose" : "ConnectionBomHose", "ConnectionBomTube" : "ConnectionBomTube", "DevicePurchaseList" : "DevicePurchaseList", "CablePurchaseList" : "CablePurchaseList"});

export default SPLM;